import Component from '../abstracts/Component';
const {
  Crawler,
} = require('./../../../../node_modules/es6-crawler-detect/src');
/**
 Recommendation Engine Component
 */

export default class RecommendationEngineComponent extends Component {
  static get SELECTORS() {
    return {
      RECOMMENDATION_ENGINE_CONTAINER: '[data-recommendation-engine]',
      RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER:
        '[data-recommendation-engine-products]',
      RECOMMENDATION_TITLE: '[data-recommendation-title]',
      RECOMMENDATION_GRID_LAYOUT: '.w-recommendation__wrapper--grid-layout',
    };
  }

  static get CONSTANTS() {
    let contextPath = document
      .getElementsByTagName('HTML')[0]
      .getAttribute('data-context');
    return {
      RECOMMENDATION_ENGINE_URL: contextPath + '/ajax/recommendation',
      GET: 'GET',
    };
  }

  render() {
    let recommendationComponent = document.querySelector(
      RecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER
    );

    if (recommendationComponent != null) {
      this.setup(recommendationComponent);
    }
  }

  constructor() {
    super();
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    opts.webRecommendationHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode;
    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode;
    return opts;
  }

  callServer(paramsObj, callBackOnSuccess, callBackOnFailure, timeoutTime) {
    let xhttp = new XMLHttpRequest();
    let params = new URLSearchParams();

    for (let key in paramsObj) {
      params.append(key, paramsObj[key]);
    }

    if (timeoutTime != null) {
      xhttp.timeout = timeoutTime;
    }

    xhttp.open(
      RecommendationEngineComponent.CONSTANTS.GET,
      RecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL +
        '?' +
        params.toString().replace(/\+/gi, '%20'),
      true
    );

    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        callBackOnSuccess(this);
      } else {
        if (
          this.readyState === 4 &&
          (this.status === 500 || this.status === 404)
        ) {
          callBackOnFailure();
        }
      }
    };

    xhttp.ontimeout = function() {
      callBackOnFailure();
    };

    xhttp.onerror = function() {
      callBackOnFailure();
    };

    xhttp.send();
  }

  renderData(data) {
    let recommendationProductsComponent = document.querySelector(
      RecommendationEngineComponent.SELECTORS
        .RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER
    );

    let recommendationTitle = document.querySelector(
      RecommendationEngineComponent.SELECTORS.RECOMMENDATION_TITLE
    );

    let recommendationGridLayout = document.querySelector(
      RecommendationEngineComponent.SELECTORS.RECOMMENDATION_GRID_LAYOUT
     );

    if (recommendationProductsComponent != null) {
      recommendationProductsComponent.innerHTML = data.responseText;
      if (data.responseText.trim() != '') {
        $(recommendationTitle).css('display', 'flex');
      }
      this.$emit(this.$customEvents.LOAD_COMPONENT.simplebar);
      this.$emit(this.$customEvents.CAROUSEL.carouselLoaded, {carousel: recommendationProductsComponent});
      if (recommendationGridLayout) {
        try {
          const response = new DOMParser().parseFromString(data?.response, 'text/html');
          this.$emit(this.$customEvents.RECOMMENDATION_EVENTS.loaded, {response});
        } catch(error){
          this.log("Failed to parse response from rec. engine")
        }
      }
    }
  }

  tryAgain() {
    let recommendationComponent = document.querySelector(
      RecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER
    );
    this.callServer(
      this.getSimilarOpts(recommendationComponent),
      this.renderData.bind(this),
      this.hideComponent.bind(this),
      null
    );
  }

  hideComponent() {
    let recommendationComponent = document.querySelector(
      RecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER
    );

    if (recommendationComponent != null) {
      recommendationComponent.innerHTML = '';
    }
  }

  setup(recommendationComponent) {
    let timeout = recommendationComponent.dataset.timeout;
    let template = recommendationComponent.dataset.template;
    let CrawlerDetector = new Crawler();
    let userAgentString = navigator.userAgent;
    if (!CrawlerDetector.isCrawler(userAgentString)) {
      this.callServer(
        this.getMarketingOpts(recommendationComponent),
        this.renderData.bind(this),
        template === 't-product'
          ? this.tryAgain.bind(this)
          : this.hideComponent.bind(this),
        timeout
      );
    } else {
      this.hideComponent();
    }
  }
}
